import { ButtonTooltip } from "../../../../shared/components/buttons/button-tooltip.js";
import { PlayButton } from "../../../components/buttons/play-button.js";
import { BufferingIndicator } from "../../../components/feedback/buffering-indicator.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-audio/skins/shared/audio/play-button.tsx
/** @jsxImportSource react */
function AudioPlayButton({ className, ...props } = {}) {
	return /* @__PURE__ */ jsxs("div", {
		className: cn("audio-play-button", className),
		...props,
		children: [/* @__PURE__ */ jsx(BufferingIndicator, { className: "audio-play-button-buffering-indicator" }), /* @__PURE__ */ jsx(ButtonTooltip, {
			boundary: "viewport",
			side: "top",
			children: /* @__PURE__ */ jsx(PlayButton, {})
		})]
	});
}
//#endregion
export { AudioPlayButton };

//# sourceMappingURL=play-button.js.map